import { render, staticRenderFns } from "./Industrial.vue?vue&type=template&id=df46941a&scoped=true&"
import script from "./Industrial.vue?vue&type=script&lang=js&"
export * from "./Industrial.vue?vue&type=script&lang=js&"
import style0 from "./Industrial.vue?vue&type=style&index=0&id=df46941a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df46941a",
  null
  
)

export default component.exports